<template>
	<div :class="['row', 'mb-3', 'fieldgroup', 'w-full']">
		<div class="month-col fieldgroup disabled">
			<select
				:value="period.startMonth"
				class="period-row-input"
			>
				<option :value="period.startMonth">{{period.startMonth}}</option>
			</select>

		</div>

		<div v-if="!isLast" class="ml-4 fieldgroup month-col disabled">
			<select
					:value="period.endMonth"
					class="period-row-input"
				>
				<option :value="period.endMonth">{{period.endMonth}}</option>
			</select>
		</div>

		<div v-if="isLast" class="ml-4 fieldgroup month-col">
			<select
					:value="period.endMonth"
					@input="e => update('endMonth', e.target.value)"
					class="period-row-input"
				>
				<option v-for="month in availableEndMonths" :value="month" :key="month">
					{{month}}
				</option>
			</select>
		</div>

		<input
			:value="period.peakHours"
			@input="e => update('peakHours', e.target.value)"
			type="text"
			class="hour-col ml-4 period-row-input"
		>

		<div class="unit-col ml-4 field-wrap fieldgroup">
			<div class="field-unit">
				<input
					:value="period.peakDemand"
					@input="e => update('peakDemand', e.target.value)"
					type="number"
					step="0.01"
					class="period-row-input kw-unit"
				/>

				<span class="icon"><strong>$/kW</strong></span>
			</div>
		</div>

		<div class="unit-col ml-4 field-wrap fieldgroup">
			<div class="field-unit">
				<input
					:value="period.peakEnergy"
					@input="e => update('peakEnergy', e.target.value)"
					type="number"
					step="0.01"
					class="period-row-input kwh-unit"
				/>

				<span class="icon"><strong>$/kWh</strong></span>
			</div>
		</div>

		<div class="unit-col-large ml-4 field-wrap fieldgroup">
			<div class="field-unit">
				<input
					:value="period.offPeakDemand"
					@input="e => update('offPeakDemand', e.target.value)"
					type="number"
					step="0.01"
					class="period-row-input kw-unit"
				/>

				<span class="icon"><strong>$/kW</strong></span>
			</div>
		</div>

		<div class="unit-col ml-4 field-wrap fieldgroup">
			<div class="field-unit">
				<input
					:value="period.offPeakEnergy"
					@input="e => update('offPeakEnergy', e.target.value)"
					type="number"
					step="0.01"
					class="period-row-input kwh-unit"
				/>

				<span class="icon"><strong>$/kWh</strong></span>
			</div>
		</div>

		<div
			v-if="isLast && period.startMonth !== 'January'"
			class="ml-4 remove-period-icon"
			@click="removeLastPeriod"
		>
			<i class="fa-solid fa-x" />
		</div>
	</div>
</template>

<script>
export default {
	name: "PeriodRow",

	props: {
		period: Object,
		update: Function,
		removeLastPeriod: Function,
		isLast: {
			type: Boolean,
			default: false,
		},
		availableEndMonths: Array,
	},
}
</script>

<style scoped>
.unit-col {
	width: 168px;
}

.unit-col-large {
	width: 175px;
}

.period-row-input {
	padding: 8px 16px;
}

.unit-col input.kw-unit {
	width: 110px;
}

.unit-col input.kwh-unit {
	width: 99px;
}

.month-col {
	width: 138px;
}

.hour-col {
	width: 130px;
}

.field-unit .icon {
	position: absolute;
	width:  auto;
	padding: 12px 8px;
	right: 0;
}

.remove-period-icon {
	display: flex;
	align-items: center;
	cursor: pointer;
	opacity: .7;
}

.remove-period-icon:hover {
	opacity: 1;
}
</style>
